import React, { useEffect, useRef } from 'react';
import {
    Flex,
    Container,
    Link,
    HStack,
} from '@chakra-ui/react';
import PatternBG from '../../assets/Home/Dremotech_Illustration.webp';
import { FaFacebookF, FaYoutube, FaInstagram, FaTwitter, FaLinkedin } from 'react-icons/fa';
import VanillaTilt from "vanilla-tilt";
import '@google/model-viewer';
import { FaCaretRight } from "react-icons/fa6";
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet'; // For managing document head



const socialLinks = [
    { name: 'Facebook', icon: FaFacebookF, url: 'https://www.facebook.com/share/16AVRur1Gm/?mibextid=wwXIfr' },
    { name: 'Instagram', icon: FaInstagram, url: 'https://www.instagram.com/dremotechsolutions' },
    { name: 'Linkedin', icon: FaLinkedin, url: 'https://www.linkedin.com/company/dremotech' },
];


function LandingPage() {
    const tiltRef = useRef(null);
    const navigate = useNavigate();


    useEffect(() => {
        // Initialize VanillaTilt
        if (tiltRef.current) {
            VanillaTilt.init(tiltRef.current, {
                max: 10,
                speed: 100,
                glare: true,
                "max-glare": 0,
            });
        }

        // Initialize particles.js
        if (window.particlesJS) {
            window.particlesJS('particles-js', {
                particles: {
                    number: { value: 80, density: { enable: true, value_area: 400 } },
                    color: { value: '#0E79AD' },
                    shape: { type: 'circle', stroke: { width: 0, color: '#000000' } },
                    opacity: { value: 0.5, random: false },
                    size: { value: 3, random: true },
                    line_linked: { enable: false },
                    move: {
                        enable: true,
                        speed: 2,
                        direction: 'none',
                        random: false,
                        straight: false,
                        out_mode: 'out',
                        bounce: false,
                    },
                },
                interactivity: {
                    detect_on: 'canvas',
                    events: {
                        onhover: { enable: true, mode: 'repulse' },
                        onclick: { enable: true, mode: 'push' },
                        resize: true,
                    },
                    modes: {
                        repulse: { distance: 100, duration: 0.4 },
                        push: { particles_nb: 4 },
                    },
                },
                retina_detect: true,
            });
        }

        return () => {
            // Clean up VanillaTilt
            if (tiltRef.current?.vanillaTilt) {
                tiltRef.current.vanillaTilt.destroy();
            }

            // Clean up particles.js
            if (window.pJSDom && window.pJSDom.length) {
                window.pJSDom.forEach(p => p.pJS.fn.vendors.destroypJS());
                window.pJSDom = [];
            }
        };
    }, []);

    return (
        <section className="page-hero d-flex align-items-center" id="page-hero" data-aos="fade-up">
            <div className="overlay-photo-image-bg"
                data-bg-img="assets/images/sections-bg-images/pattern-bg-1.jpg"
                data-bg-opacity=".2"></div>
            <div className="particles-js dots" id="particles-js"></div>
            <div className="container">
                <div className="row">
                    <div className="col-12 col-lg-6 p-3">
                        <div className="hero-text-area">
                            <div className="row">
                                <div className="col-12">
                                    <h1 className="hero-title">
                                        Affordable & Reliable IT <span className="featured-text">
                                            solutions
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 150" preserveAspectRatio="none">
                                                <path d="M7.7,145.6C109,125,299.9,116.2,401,121.3c42.1,2.2,87.6,11.8,87.3,25.7" />
                                            </svg>
                                        </span>
                                    </h1>
                                </div>
                                <div className="col-10">
                                    <p className="hero-subtitle">
                                        At Dremotech, we turn your ideas into powerful websites, apps, and digital experiences. From Custom Web Development to AR/VR solutions — your growth is our expertise.
                                    </p>
                                </div>
                                <div className="col-12">
                                    <div className="hero-social-icons mb-3">
                                        <div className="sc-wrapper dir-row sc-flat">
                                            {/* <ul className="sc-list">
                                                <li className="sc-item" title="Facebook"><a className="sc-link" href="#0"><FaFacebookF /></a></li>
                                                <li className="sc-item" title="Youtube"><a className="sc-link" href="#0"><FaYoutube /></a></li>
                                                <li className="sc-item" title="Instagram"><a className="sc-link" href="#0"><FaInstagram /></a></li>
                                            </ul> */}
                                            <HStack spacing={4}>
                                                {socialLinks.map((social) => (
                                                    <Link
                                                        key={social.name}
                                                        as="a"
                                                        href={social.url}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        aria-label={social.name}
                                                        display="flex"
                                                        alignItems="center"
                                                        justifyContent="center"
                                                        w="40px"
                                                        h="40px"
                                                        border="2px solid"
                                                        borderColor="customBlue.500"
                                                        borderRadius="full"
                                                        color="customBlue.500"
                                                        _hover={{ bg: 'customBlue.500', color: 'white' }}
                                                    >
                                                        <social.icon size="20px" />
                                                    </Link>
                                                ))}
                                            </HStack>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="cta-links-area">
                                        <a className="btn-outline cta-link cta-link-primary" onClick={() => navigate('/services')}>Get Started  <FaCaretRight size={28} /></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Flex ref={tiltRef} className="col-12 mx-md-auto col-lg-6" >
                        <div className="hero-image-area mb-5 mb-lg-0">
                            <div className="hero-img-wraper">
                                <img className="img-fluid" src={PatternBG} alt="Pattern" draggable="false" />
                            </div>
                        </div>
                    </Flex>
                </div>
            </div>
        </section>
    );
}

export default LandingPage;